<template>
  <!-- [sc-48351] Tabella vuota: nato nei Listini, ora in tutte le liste.
       Distingue una lista ancora da riempire - il caso normale al primo
       accesso - da una ricerca senza risultati; l'azione la passa la pagina. -->
  <div class="empty-state">
    <i class="fa-solid empty-state__icon" :class="icon" aria-hidden="true"></i>
    <p class="empty-state__title">{{ title }}</p>
    <p v-if="text" class="empty-state__text">{{ text }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: "fa-box-open" },
    title: { type: String, required: true },
    text: { type: String, default: "" },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 20px;
  text-align: center;
  /* Le celle di `.tbl` sono `white-space: nowrap` (App.css): senza questo il
     testo resterebbe su una riga sola e il `max-width` non avrebbe effetto. */
  white-space: normal;
}

.empty-state__icon {
  font-size: 34px;
  color: #cbd5e1;
}

.empty-state__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #334155;
}

.empty-state__text {
  margin: 0;
  max-width: 44ch;
  font-size: 14px;
  line-height: 1.5;
  color: #64748b;
}

/* Le azioni arrivano dallo slot: `:slotted` le raggiunge con lo scope. */
.empty-state :slotted(.primary-btn) {
  margin-top: 6px;
}

.empty-state :slotted(.empty-state__reset) {
  margin-top: 6px;
  padding: 8px 14px;
  background: transparent;
  border: 0.5px solid var(--border, #e4e4e7);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--brand-on-light, var(--brand));
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.empty-state :slotted(.empty-state__reset:hover) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}
</style>
